'use client';

import { FC, useMemo } from 'react';

import { AddressLocation } from '@ravago/shared/page-data/models/elements';

import { AdvancedMarker } from '@vis.gl/react-google-maps';

import { convertStringToLatLng } from '../../../../utils/location/location.utils';

import { AddressPanel } from './address-panel';

export const AddressMarker: FC<AddressLocation & { active: boolean; onClick: () => void; onClose: () => void }> = ({
   latLng,
   title,
   details,
   website,
   active,
   onClick,
   onClose
}) => {
   const { lat, lng } = useMemo(() => convertStringToLatLng(latLng), [latLng]);

   return (
      <>
         <AdvancedMarker position={{ lat, lng }} onClick={onClick} />
         {active && <AddressPanel title={title} details={details} website={website} onClose={onClose} />}
      </>
   );
};
